import { Badge } from '@/components/ui/badge'
import type { ThreatActor } from '@/lib/types'

export interface ActorContextStripProps {
  actor: ThreatActor
}

export function ActorContextStrip({ actor }: ActorContextStripProps) {
  const aliases = actor.aliases?.filter(Boolean) ?? []

  return (
    <section
      aria-label="Threat actor context"
      className="space-y-3 rounded-lg border bg-card p-4"
    >
      <h2 className="text-2xl font-bold leading-tight text-foreground">
        {actor.name}
      </h2>

      {aliases.length > 0 && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Also known as
          </span>
          {aliases.map((alias) => (
            <Badge key={alias} variant="secondary">
              {alias}
            </Badge>
          ))}
        </div>
      )}

      <div className="flex flex-wrap items-center gap-2">

        {actor.attribution && (
          <Badge variant="outline" className="capitalize">
            {actor.attribution}
          </Badge>
        )}
      </div>


    </section>
  )
}
